module.exports = __webpack_public_path__ + "img/Chennai.41e07b43.png";